import serviceADX from "@/helpers/py-service";

const state = {
  loading: false,
  dropdownloading: false,
  meta: {},
  list: [],
  dropDownlist: [],
};

const mutations = {
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LOADING_LIST(state, value) {
    state.loading = value;
  },
  UPDATE_TERMINAL(state, row) {
    const item = state.list.find((item) => item.id === row.id);
    Object.assign(item, row);
  },
  SET_LIST_DROPDOWN(state, value) {
    state.dropDownlist = value;
  },
};

const actions = {
  setLoadingValue: (store, value) => {
    store.commit("SET_LOADING_LIST", value);
  },
  dropDownList: (store, params) => {
    store.state.dropdownloading = true;
    return serviceADX
      .get("fuel-management/terminals-dropdown", params)
      .then((data) => {
        store.commit("SET_LIST_DROPDOWN", data.body);
        return data.body;
      })
      .finally(() => (store.state.dropdownloading = false));
  },
  list: (store, params) => {
    store.state.loading = true;
    return serviceADX
      .get("fuel-management/terminals", params)
      .then((data) => {
        if (data.body?.data) {
          store.commit("SET_LIST", data.body.data);
          store.commit("SET_META", data.body);

          return data.body.data;
        } else {
          store.commit("SET_LIST", data.body);
          return data.body;
        }
      })
      .finally(() => (store.state.loading = false));
  },
  addTerminal: (store, { payload, filter }) => {
    store.state.loading = true;
    return serviceADX
      .post("fuel-management/terminals", payload)
      .then(() => {
        store.dispatch("list", filter);
      })
      .finally(() => (store.state.loading = false));
  },
  updateTerminal: (store, params) => {
    return serviceADX
      .put(`fuel-management/terminals/${params.id}`, params)
      .then((data) => {
        store.commit("UPDATE_TERMINAL", data.body);
        return data;
      })
      .finally(() => (store.state.loading = false));
  },
  destroy: (store, params) => {
    return serviceADX.destroy(`fuel-management/terminals/${params.id}`);
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getDropdownloading(state) {
    return state.dropdownloading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  getTerminalDropDown(state) {
    return state.dropDownlist;
  },
};

const csmsChargingSession = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default csmsChargingSession;
